import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Categories from "../pages/categories/page";
import ProductDetail from "../pages/product/page";
import ArticlePage from "../pages/article/page";
import DealsPage from "../pages/deals/page";

import GuidesPage from "../pages/guides/page";
import SearchPage from "../pages/search/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/busca", element: <SearchPage /> },
  { path: "/ofertas", element: <DealsPage /> },
  { path: "/guias", element: <GuidesPage /> },
  { path: "/categorias", element: <Categories /> },
  { path: "/categoria/:slug", element: <Categories /> },
  { path: "/categoria/:slug/:subslug", element: <Categories /> },
  { path: "/produto/:slug", element: <ProductDetail /> },
  { path: "/artigo/:slug", element: <ArticlePage /> },
  { path: "/admin/*", element: <AdminPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
